import React, { Component } from "react"
import { Helmet } from "react-helmet";
import Layout from "../components/layout";
import "../css/style.css";
import "../css/animate.min.css";
import "../css/responsive.css";
import "../css/bootstrap.min.css";
import downArrow from '../images/down-arrow.svg'
import Swiper, { Navigation, Pagination, Scrollbar, Autoplay, Thumbs, Mousewheel, Parallax } from 'swiper';
import ScrollAnimation from 'react-animate-on-scroll';
import { Animated } from "react-animated-css";
import PopupForm from "../components/popupForm";

Swiper.use([Navigation, Pagination, Autoplay, Scrollbar, Thumbs, Mousewheel, Parallax]);
var accItem;
class UniSmarterFaqSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      time: 90000000
    }
  }

  handlePopupWindow = () => {
    this.setState({ time: Math.random() })
  }

  componentDidMount() {

    accItem = document.getElementsByClassName('accordionItem');
    let accHD = document.getElementsByClassName('accordionItemHeading');
    for (let i = 0; i < accHD.length; i++) {
      accHD[i].addEventListener('click', this.toggleItem, false);
    }
  }
  accorfn = () => {

    accItem = document.getElementsByClassName('accordionItem');
    let accHD = document.getElementsByClassName('accordionItemHeading');
    for (let i = 0; i < accHD.length; i++) {
      accHD[i].addEventListener('click', this.toggleItem, false);
    }

  }
  toggleItem() {

    var itemClass = this.parentNode.className;
    for (let i = 0; i < accItem.length; i++) {
      accItem[i].className = 'accordionItem close';
    }
    if (itemClass == 'accordionItem close') {
      this.parentNode.className = 'accordionItem open';
    }
  }

  render() {

    return (

      <div>
        <PopupForm time={this.state.time} />
          
          {/* <section class="faq-sec"> */}

            <Animated animationIn="fadeInUp" animationOut="fadeInDown" isVisible={true}>

              <div class="container-fluid">
                <div class="row">
                  <div class="col-12">
                    <div id="american-dream-faq-inner" class="wow fadeInUp" data-wow-duration="1s" data-wow-delay=".2s">

                      <div class="accordionWrapper">

                        <div id="american-dream-accordian" class="accordionItem open" onClick={() => this.accorfn()} >
                          <h2 class="accordionItemHeading" >What is the Global Online Accelerator Program?<span><img src={downArrow} alt="" /></span></h2>
                          <div class="accordionItemContent">
                            <p>
                              The Global Online Accelerator (GOA) Program has been developed in collaboration with UOW College, Australia which is a part of the University of Wollongong (global top 200). Students can do upto half of their first year of undergraduate studies in Business or Technology and articulate to UOW College and UOW for the rest of the program. Students study in UOW College’s online environment and receive a transcript from the college upon completion.
                            </p>
                          </div>
                        </div>
                        <div id="american-dream-accordian" class="accordionItem close" onclick={() => this.accorfn()}>
                          <h2 class="accordionItemHeading">Is the Global Online Accelerator Program recognised?<span><img src={downArrow} alt="" /></span></h2>
                          <div class="accordionItemContent">
                            <p>
                              Global Online Accelerator Online program is fully recognised by our partner institutions for entry into their undergraduate and postgraduate degrees. You can learn more about our partner institutions by visiting partners. All of our online programs are designed in collaboration with overseas partners and are taught by international faculty members.
                            </p>
                          </div>
                        </div>

                        <div id="american-dream-accordian" class="accordionItem close" onclick={() => this.accorfn()}>
                          <h2 class="accordionItemHeading" >What are the fees for Global Online Accelerator Program?<span><img src={downArrow} alt="" /></span></h2>
                          <div class="accordionItemContent">
                            <p>
                              The fees for Global Online Accelerator programs starts from INR 3,48,000 + GST and varies for different courses.
                            </p>
                          </div>
                        </div>

                        <div id="american-dream-accordian" class="accordionItem close" onclick={() => this.accorfn()}>
                          <h2 class="accordionItemHeading">What will happen if your visa gets rejected?<span><img src={downArrow} alt="" /></span></h2>
                          <div class="accordionItemContent">
                            <p>
                              Students who have passed The WorldGrad online programs are entitled to a full refund of their online program fee if their study visa application is rejected for any reason other than fraudulent or unverifiable documentation. Please speak to our admissions counsellors for more information.
                            </p>
                          </div>
                        </div>
                        
                      </div>
                      {/* <div class="enquire-btn">
                        <a class="btn btn-default" onClick={() => this.handlePopupWindow()}>Speak With Us</a>
                      </div> */}
                    </div>
                  </div>
                </div>
              </div>
            </Animated>
          {/* </section> */}
        {/* </Layout> */}
      </div>
    )
  }
}
export default UniSmarterFaqSection;
